module.exports = __webpack_public_path__ + "static/media/place.00694e9a.svg";